<template>
    <div id="SuccessDiv">
        <HeaderVue isHealthCartEnabled="true"/>
        <div class="search-section">
            <div class="container">
                <div class="row">
                    <div class="col-sm-10">
                        <div class="check-box float-left mr-3">
                            <img src="static/images/check.png" class="mt-2" alt=''>
                        </div>
                        <div class="float-left thank-msg">
                            <h5 class="mb-0">Thank you, your order has been placed successfully!</h5>
                            <p>Our phlebotomist will get in touch with you at the phone number that you have provided before
                                coming to collect the sample at the address mentioned.</p>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <router-link to="/myresult" class="btn btn-light full-width mar-t-15">My Orders</router-link>   
                    </div>
                </div>
            </div>
        </div>
        <!-- search-section -->
        <div class="portal-section" v-if="requestDetails" >
            <div class="container">
                <div class="row">
                    <div class="col-sm-7">
                        <div class="table-responsive">
                            <table class="table black-color">
                                <tr>
                                    <td class="no-border text-nowrap">Request ID</td>
                                    <td class="no-border">{{'REQ'+requestDetails.requestId}}</td>
                                </tr>
                                <tr>
                                    <td class="no-border text-nowrap">Patient Name</td>
                                    <td class="no-border">{{requestDetails.reqPatientFirstName+' '+requestDetails.reqPatientLastName}}</td>
                                </tr>
                                <tr>
                                    <td class="no-border text-nowrap">Appointment Date & Time</td>
                                    <td class="no-border">
                                        <div class="green-outline">
                                            {{appointmentDate}}&nbsp;&nbsp;|&nbsp;&nbsp;{{appointmentStartTime}} to {{appointmentEndTime}}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="no-border text-nowrap">Sample Collection Address</td>
                                    <td class="no-border">
                                        <address>
                                            {{requestDetails.pickupAddress}}
                                            <br> M: {{requestDetails.reqPatientMobile}}
                                        </address>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="lab display-flex no-border p-0 mt-0">
                            <div class="flex-box">
                                <div class="lab-logo">
                                    <img v-if="requestDetails.Lab.logo" :src="$s3BucketUrl + requestDetails.Lab.logo" />
                                </div>
                            </div>
                            <div class="flex-box">
                                <h6 class="black-color">{{requestDetails.Lab.labName}}</h6>
                                <p class="grey-color">{{requestDetails.LabBranch.Address.Location.locationName}}, {{requestDetails.LabBranch.Address.City.cityName}}, {{requestDetails.LabBranch.Address.State.stateName}} - {{requestDetails.LabBranch.Address.zipCode}}</p>
                            </div>
                        </div>
                        <div class="table-responsive test-conformation">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="no-border">Test Name</th>
                                        <th class="no-border"></th>
                                        <th class="text-right no-border">Price</th>
                                    </tr>
                                </thead>
                                <tbody class="black-color">
                                    <tr v-for="(requestTest, index) in requestDetails.RequestTests" :key='index'>
                                        <td colspan="2" v-if="requestTest">
                                          <span>{{requestTest.Profile?(requestTest.Profile.panelName):(requestTest.Test.testName)}}</span>
                                        </td>
                                        <td>
                                            <span class="float-right">
                                                <!--<span class="red-color strip-text">Rs. {{requestTest.testCost}} </span> -->
                                                Rs. {{requestTest.testCost}}
                                            </span>
                                        </td>
                                        <!--<td>
                                            <button class="btn btn-link remove-btn p-0">
                                                <img src="static/images/close-black.svg" alt=''>
                                            </button>
                                        </td>-->
                                    </tr>
                                    <tr v-if="requestDetails.phlebCost && requestDetails.phlebCost > 0">
                                        <td class="no-border"></td>
                                        <td>Phlebotomist Fee</td>
                                        <td >
                                            <span class="float-right">
                                               + Rs. {{requestDetails.phlebCost}}
                                            </span>
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr class="grey-color">
                                        <td class="no-border"></td>
                                        <td>Sub Total</td>
                                        <td>
                                            <h5 class="float-right mt-1 mb-0 price-tags">
                                                Rs. {{(requestDetails.cost-requestDetails.discountCost) + (requestDetails.phlebCost && requestDetails.phlebCost > 0 ? requestDetails.phlebCost : 0)}}
                                            </h5>
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr v-if="requestDetails.couponCost">
                                        <td class="no-border"></td>
                                        <td>Coupon Discount</td>
                                        <td >
                                            <h5 class="float-right mt-1 mb-0 price-tags green-color">
                                                - Rs.{{requestDetails.couponCost}}
                                            </h5>
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr v-if="requestDetails.creditDiscount && requestDetails.creditDiscount > 0">
                                        <td class="no-border"></td>
                                        <td>Credits Applied</td>
                                        <td >
                                            <h5 class="float-right mt-1 mb-0 price-tags green-color">
                                                - Rs.{{requestDetails.creditDiscount}}
                                            </h5>
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr v-if="requestDetails.paymentType == 1">
                                        <td class="no-border"></td>
                                        <td class="border-bottom">Cash Due</td>
                                        <td class="border-bottom">
                                            <h5 class="float-right mt-1 mb-0 price-tags">
                                                Rs. {{requestDetails.totalUnpaidCost}}
                                            </h5>
                                        </td>
                                        <td class="border-bottom"></td>
                                    </tr>
                                    <tr v-else>
                                        <td class="no-border"></td>
                                        <td class="border-bottom">Amount Paid</td>
                                        <td class="border-bottom">
                                            <h5 class="float-right mt-1 mb-0 price-tags">
                                                Rs. {{requestDetails.totalPaidCost}}
                                            </h5>
                                        </td>
                                        <td class="border-bottom"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <button class="btn btn-outline-primary mt-4" v-on:click="goHome()">
                            Go to Home page
                        </button>
                    </div>
                    <div class="col-sm-4 offset-sm-1">
                        <!--<p class="theme-font mb-1">Before Home Sample Pickup</p>
                        <p class="black-color mb-4">Do not eat or drink anything except water at least 9 to 12 hours before the test.</p>-->
                        <!--<div class="alert alert-secondary" role="alert">
                            <div class="request-feedback">
                                <button class="btn btn-outline-primary full-width white-bg" onclick="$('.request-feedback').hide() $('.feedback-form').show()">
                                    Request Your Feedback
                                </button>
                                <p class="mt-2">Your feedback will help us bring you an even better experience!</p>
                            </div>
                            <div class="feedback-form"  style="display:none">
                                <h3>Feedback Form</h3>
                                <p>Your feedback will help us bring you an even better experience!</p>
                                <p>
                                    <b>Was it easy to browse the Test Selection?</b>
                                </p>
                                <ul class="feedback-option">
                                    <li>
                                        <input type="radio" name="easyBrowse"> Excellent
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Good
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Decent
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Poor
                                    </li>
                                </ul>
                                <p>
                                    <b>Did you find your closest appropriate lab?</b>
                                </p>
                                <ul class="feedback-option">
                                    <li>
                                        <input type="radio" name="easyBrowse"> Excellent
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Good
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Decent
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Poor
                                    </li>
                                </ul>
                                <p>
                                    <b>Was it convienent to select date and time?</b>
                                </p>
                                <ul class="feedback-option">
                                    <li>
                                        <input type="radio" name="easyBrowse"> Excellent
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Good
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Decent
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Poor
                                    </li>
                                </ul>
                                <p>
                                    <b>Preparation guide was clear enough?</b>
                                </p>
                                <ul class="feedback-option">
                                    <li>
                                        <input type="radio" name="easyBrowse"> Excellent
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Good
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Decent
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Poor
                                    </li>
                                </ul>
                                <p>
                                    <b>Overal experience with Labotist?</b>
                                </p>
                                <ul class="feedback-option">
                                    <li>
                                        <input type="radio" name="easyBrowse"> Excellent
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Good
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Decent
                                    </li>
                                    <li>
                                        <input type="radio" name="easyBrowse"> Poor
                                    </li>
                                </ul>
                                <button class="btn btn-primary full-width mt-3" onclick="$('.feedback-form').hide() $('.feedback-thankyou').show()">Submit</button>
                            </div>
                            <div class="feedback-thankyou"  style="display:none">
                                <h4 class="text-center pt-5 pb-5">Thank you for your Feedback!</h4>
                            </div>
                        </div>-->
                    </div>
                </div>
            </div>
        </div>
        <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'

export default {
  name: 'SuccessRequest',
  props: ['sample'],
  components: {
    HeaderVue,
    FooterVue
  },
  beforeCreate () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' })
    }
  },
  data () {
    return {
      requestDetails: {},
      s3BucketUrl: '',
      appointmentDate: '',
      appointmentStartTime: '',
      appointmentEndTime: ''
    }
  },
  methods: {
    getRequestDetails: function (requestId) {
      try {
        this.requestDetails = {}
        var data = {
          'requestId': requestId
        }
        Promise.resolve(this.$GET('patient/getRequestById', data)).then(function (res) {
          this.requestDetails = {}
          this.$hidePageLoading()
          if (res.response_code === 0) {
            this.requestDetails = res.response
            this.s3BucketUrl = res.response.Lab.logo && res.response.Lab.logo.length > 0 ? this.$s3BucketUrl + res.response.Lab.logo : ''
            this.appointmentDate = ''
            this.appointmentStartTime = ''
            this.appointmentEndTime = ''
            if (res.response.appointmentDateDisp) {
              this.appointmentDate = res.response.appointmentDateDisp
            }
            if (res.response.appointmentFromTime) {
              this.appointmentStartTime = res.response.appointmentFromTime
            }
            if (res.response.appointmentToTime) {
              this.appointmentEndTime = res.response.appointmentToTime
            }
            if (location.hostname === 'labotist.com') {
              gtag('event', 'conversion', {
                'send_to': 'AW-820857956/RXvTCLWFt3sQ5Ji1hwM',
                'value': this.requestDetails.totalPaidCost,
                'currency': 'INR',
                'transaction_id': this.requestDetails.paymentId
              })
            } else if (location.hostname === 'stage.labotist.com') {
              gtag('event', 'conversion', {
                'send_to': 'AW-819702604/tIrbCLnhwXsQzNbuhgM',
                'value': this.requestDetails.totalPaidCost,
                'currency': 'INR',
                'transaction_id': this.requestDetails.paymentId
              })
            }
            this.clearRequestSessions()
          }
        }.bind(this)).catch(function (err) {
          console.log(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    clearRequestSessions: function () {
      this.$localStorage.remove('pincode')
      this.$localStorage.remove('location')
      this.$localStorage.remove('st')
      this.$localStorage.remove('sl')
      this.$localStorage.remove('ct')
      this.$localStorage.remove('sa')
      this.$localStorage.remove('sm')
      this.$localStorage.remove('cou')
    },
    goHome: function () {
      this.$router.push({ path: '/' })
    },
    getProfile: function () {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {}
          Promise.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
                let userDetails = {
                'username': res.response.Patient.firstName + ' ' + res.response.Patient.lastName,
                'firstName': res.response.Patient.firstName,
                'lastName': res.response.Patient.lastName,
                'photo': res.response.Patient.photo,
                'dob': res.response.Patient.dob,
                'phone1': res.response.Patient.phone1,
                'phone2': res.response.Patient.phone2,
                'sex': res.response.Patient.sex,
                'email': res.response.email,
                'credits': res.response.Patient.creditPoint
                }
                this.$localStorage.set('profile', userDetails, 0)
            }
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error('method:getProfile', e)
      }
    }
  },
  created () {
    if (global.successId > 0) {
      this.getRequestDetails(global.successId)
    } else {
      this.$router.push({ path: '/' })
    }
    this.getProfile()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/Book/Secure/Success.vue